export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "device_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prix de l'appareil"])},
        "customer_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prix client"])},
        "current_bonus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prime vendeur actuelle"])},
        "new_bonus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvelle prime vendeur"])}
      },
      "en": {
        "device_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Device price"])},
        "customer_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer price"])},
        "current_bonus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current seller bonus"])},
        "new_bonus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New seller bonus"])}
      }
    }
  })
}
